import { html, nothing } from 'lit';

export type StatusTone = 'success' | 'warning' | 'error' | 'info' | 'neutral';

/**
 * The class strings are written out per tone because the tailwind scanner only picks up literal tokens,
 * an interpolated `bg-${tone}/10` would silently render unstyled.
 */
const TONE_CLASS: Record<StatusTone, string> = {
  success: 'border-success/30 bg-success/10 text-success',
  warning: 'border-warning/40 bg-warning/10 text-warning',
  error: 'border-error/30 bg-error/10 text-error',
  info: 'border-info/30 bg-info/10 text-info',
  neutral: 'border-base-300 bg-base-200 text-base-content/70',
};

/**
 * A compact status pill. Conveys state through an icon and a label instead of a background tint alone, so the
 * meaning stays readable for colorblind users and does not compete with the surrounding content.
 */
export const StatusBadge = (props: {
  tone: StatusTone;
  label: string;
  /** literal iconify class, i.e. `icon-[material-symbols--check-circle-outline]` */
  iconClass?: string;
  size?: 'sm' | 'md';
  title?: string;
}) => html`
  <span
    class="inline-flex shrink-0 items-center gap-1 whitespace-nowrap rounded-full border font-semibold ${
      TONE_CLASS[props.tone]
    } ${props.size === 'md' ? 'px-2.5 py-1 text-sm' : 'px-2 py-0.5 text-sm'}"
    title=${props.title ?? nothing}
  >
    ${props.iconClass ? html`<span class="${props.iconClass} text-sm"></span>` : nothing} ${props.label}
  </span>
`;
